import { useAppSelector } from "redux/hooks";
import { selectDuplicateEntities, selectDuplicateRules } from "redux/slices/lensEditor";
import { P } from "theme/typography";
import { nonEmpty } from "helpers/coll";
import { Box, List, ListItem } from "@mui/material";
import LensEditorHeader from "./LensEditorHeader";
import { RuleMode } from "routes/lens-editor/RuleMode";

const Duplicates = () => {
  const duplicateRules = useAppSelector(selectDuplicateRules);
  const duplicateEntities = useAppSelector(selectDuplicateEntities);

  return (
    <Box sx={{ px: 1 }}>
      <LensEditorHeader />
      <Box p={2}>
        {nonEmpty(duplicateRules) && (
          <>
            <P variant="h6">Duplicate Rules</P>
            <List sx={{ overflow: "auto" }}>
              {duplicateRules.map(([rule]) => {
                return (
                  <ListItem key={rule.ruleId} divider>
                    <RuleMode rule={rule} linkToDuplicates />
                  </ListItem>
                );
              })}
            </List>
          </>
        )}
        {nonEmpty(duplicateEntities) && (
          <>
            <P sx={{ marginY: 1 }} variant="h6">
              Duplicate Entities
            </P>
            <List sx={{ overflow: "auto" }}>
              {duplicateEntities.map(([, rule]) => {
                return (
                  <ListItem key={rule.ruleId} divider>
                    <RuleMode rule={rule} linkToDuplicates />
                  </ListItem>
                );
              })}
            </List>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Duplicates;
